<template>  
  <div class="card">
    <div class="up">
      <div id="img-container">
        <img v-bind:src="imgUrl" v-on:click="click(warheadName, true)"> 
      </div>
      <input type="checkbox" 
             name="checkbox_warhead" 
     v-bind:value="warheadName" 
        v-bind:id="'checkbox_warhead_'+warheadName" 
       v-on:click="click(warheadName, false)" 
   v-bind:checked="checked" />
    </div>
    <div class="down">
      <a target="_blank" v-bind:href="'https://en.wikipedia.org/wiki/' + warheadName" >
          {{ warheadName }}
      </a>
      <div class="count"> {{ count }} </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'warheadCard', 
  props: ['imgUrl', 'warheadName', 'count', 'checked'],   
  methods: {
    click: function (warheadName, flag) { 
      if (flag==true) {
        var checkbox = document.getElementById('checkbox_warhead_'+warheadName) 
        checkbox.checked = !checkbox.checked  
      }
      this.$emit('click_checkbox', 'checkbox_warhead')
      // console.log(warheadName)
    } 
  } 
}
</script> 
 
<style scoped>  
  .card {
    margin: 1px;
    border: 1px solid black; 
    height: 150px;
    width:  250px; 
    display: flex;
    flex-direction: column;
  }
  .up { 
    display: flex; 
    justify-content: space-between;
    position: relative;
  }
  #img-container { 
    width: 250px;
    height:130px;
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: center;
  }
  img {  
    border: 0px solid black;
    max-width: 248px;
    max-height:128px;
  }
  input {
    position: absolute;
    left: 105px;
  }
  .down {
    position: relative;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
  }
  .count{
    position: absolute;
    height: 100%;
    bottom: 0;
    right:1%;
  }

  input[type="checkbox"] { 
    zoom: 2;
  } 
</style>
